import styled from 'styled-components';

const Container = styled.div`
  margin: 1em;
  display: flex;
  flex-direction: row;
  & > * {
    margin-left: 1em;
    &:first-child {
      margin-left: 0;
    }
  }
`;

const CoverColumn = styled.div`
  text-align: center;
  & > * {
    margin-top: 1em;
    &:first-child {
      margin-top: 0;
    }
  }
`;

const DescriptionColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  & > * {
    margin-top: 1em;
    &:first-child {
      margin-top: 0;
    }
  }
`;

export default {
  Container,
  CoverColumn,
  DescriptionColumn,
};
